import type { ScreenerColumn, ScreenerSubField } from "epsm-api-types/models";
import { scorerPrefix } from "../../../default";
import { getDisplayTitle } from "../../../lib/helpers/getDisplayTitle";

export const addNestedScorerSubfields = (
	column: ScreenerColumn,
	subFields: ScreenerSubField[],
	fieldPath: string,
	parentName: string,
	parentTitle: string,
	columnMap: Record<string, ScreenerColumn>,
) => {
	const subfield = subFields.find(
		(item) =>
			item.name === fieldPath.replace(`${parentName}`, "").split(".")[1],
	);
	if (!subfield) return;

	const fullColumnName = `${parentName}.${subfield.name}`;

	if (subfield.subFields?.length) {
		addNestedScorerSubfields(
			column,
			subfield.subFields,
			fieldPath,
			fullColumnName,
			subfield.titleShort || subfield.title || subfield.name,
			columnMap,
		);
	} else {
		const { displayTitle } = getDisplayTitle(
			column,
			subfield,
			parentName,
			parentTitle,
		);
		columnMap[fieldPath] = {
			name: `${scorerPrefix}${fullColumnName}`,
			title: `SC: ${displayTitle}`,
			description: column.description,
			type: column.type,
			groupName: column.groupName,
		};
	}
};
